import { render, staticRenderFns } from "./GPageTitle.vue?vue&type=template&id=0983b0bb&scoped=true"
import script from "./GPageTitle.vue?vue&type=script&lang=js"
export * from "./GPageTitle.vue?vue&type=script&lang=js"
import style0 from "./GPageTitle.vue?vue&type=style&index=0&id=0983b0bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0983b0bb",
  null
  
)

export default component.exports